import { render, staticRenderFns } from "./OneClickCallbackPage.vue?vue&type=template&id=0ff972fc&scoped=true&"
import script from "./OneClickCallbackPage.vue?vue&type=script&lang=js&"
export * from "./OneClickCallbackPage.vue?vue&type=script&lang=js&"
import style0 from "./OneClickCallbackPage.vue?vue&type=style&index=0&id=0ff972fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff972fc",
  null
  
)

export default component.exports